import React from 'react';

import {FullHTMLLink} from 'app/components/general/FullHTMLLink/index';
import NoResultsMessage from 'app/components/general/NoResultsMessage';
import {HOME_REDIRECT} from 'app/urls';
import {gt} from 'app/utils/i18n';

export const NotFoundContent = (): JSX.Element => (
  <NoResultsMessage
    icon="fa-exclamation-triangle text-warning"
    head={gt('Document not found')}
  >
    <p className="lead mb-0">
      {gt('The document you have requested does not exist')}
    </p>
    <p className="lead">
      {gt('It may be in the Recycle Bin or permanently deleted')}
    </p>
    <p className="lead">{gt('Contact your manager for more details')} </p>
    <div>
      <FullHTMLLink html_url={HOME_REDIRECT} className="btn btn-primary">
        <i className="fa fa-arrow-left" /> {gt('Back to home')}
      </FullHTMLLink>
    </div>
  </NoResultsMessage>
);
